// @tennis-matches/core/utils
// Alphanumerische ID (Base32 ohne leicht verwechselbare Zeichen)
// -> gut zum Teilen, schwer zu erraten.

const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // no I, O, 0, 1

export function generateId(len = 16) {
  const n = Math.max(8, Math.min(64, Math.trunc(Number(len) || 16)));
  const bytes = new Uint8Array(n);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < n; i++) out += ALPHABET[bytes[i] % ALPHABET.length];
  return out;
}

/**
 * Short tournament / share code (allows 6 chars, no confusing chars).
 * Use when you explicitly want very short IDs for manual entry.
 */
export function generateCode(len = 6) {
  const n = Math.max(4, Math.min(16, Math.trunc(Number(len) || 6)));
  const bytes = new Uint8Array(n);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < n; i++) out += ALPHABET[bytes[i] % ALPHABET.length];
  return out;
}
